import React from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Downshift from 'downshift';
import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Settings from '@material-ui/icons/Settings';
import Mail from '@material-ui/icons/Mail';
import Done from '@material-ui/icons/Done';
import Edit from '@material-ui/icons/Edit';
import Map from '@material-ui/icons/Room';
import UserIcon  from '@material-ui/icons/Person';
import RoleIcon  from '@material-ui/icons/SupervisorAccount';

// eslint-disable-next-line
import style from './_style.css';

function renderInput(inputProps) {
    const { InputProps, ref, ...other } = inputProps;

    return (
        <TextField
            InputProps={{
                inputRef: ref,
                classes: {
                    root: 'inputRoot',
                },
                ...InputProps,
            }}
            {...other}
        />
    );
}

function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
    const isHighlighted = highlightedIndex === index;
    const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;
    return (
        <MenuItem
            {...itemProps}
            key={suggestion.id}
            selected={isHighlighted}
            component="div"
            style={{
                fontWeight: isSelected ? 500 : 400,
            }}
        >
            {getIcon(suggestion.type)}
            {suggestion.name}
        </MenuItem>
    );
}

function getSuggestions(suggestions, inputValue) {
    let count = 0;
    return suggestions.filter((suggestion) => {
        const keep =
            (!inputValue ||
                (suggestion &&
                    suggestion.name &&
                    suggestion.name.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1)) &&
            count < 5;

        if (keep) {
            count += 1;
        }

        return keep;
    });
}

renderSuggestion.propTypes = {
    highlightedIndex: PropTypes.number,
    index: PropTypes.number,
    itemProps: PropTypes.object,
    selectedItem: PropTypes.string,
    suggestion: PropTypes.shape({ name: PropTypes.string, id: PropTypes.number }).isRequired,
};

function getAvatar(type) {
    switch (type) {
        case 'user':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <UserIcon className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        case 'rol':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <RoleIcon className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        case 'email':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <Mail className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        case 'generator':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <Done className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        case 'system':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <Settings className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        case 'variable':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <Edit className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        case 'map':
            return (
                <Avatar className="avatar c_white bg_bluish">
                    <Map className="avatar c_white bg_bluish margin_right_6 margin_left_12" />
                </Avatar>
            );
        default:
            return null;
    }
}

function getIcon(type) {
    switch (type) {
        case 'user':
            return <UserIcon className="avatar  c_bluish margin_right_6" />;
        case 'rol':
            return <RoleIcon className="avatar  c_bluish margin_right_6" />;
        case 'email':
            return <Mail className="avatar   c_bluish margin_right_6" />;
        case 'generator':
            return <Done className="avatar   c_bluish margin_right_6" />;
        case 'system':
            return <Settings className="avatar   c_bluish margin_right_6" />;
        case 'variable':
            return <Edit className="avatar  c_bluish margin_right_6" />;
        case 'map':
            return <Map className="avatar  c_bluish margin_right_6" />;
        default:
            return null;
    }
}

export default class DownshiftMultiple extends React.Component {
    state = {
        inputValue: '',
        selectedItem: this.props.value,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ selectedItem: nextProps.value });
    }

    handleKeyDown = (event) => {
        const { inputValue, selectedItem } = this.state;
        if (selectedItem.length && !inputValue.length && keycode(event) === 'backspace') {
            this.setState({
                selectedItem: selectedItem.slice(0, selectedItem.length - 1),
            });
            this.props.onChange(this.props.name, selectedItem.slice(0, selectedItem.length - 1));
        }
    };

    handleInputChange = (event) => {
        this.setState({ inputValue: event.target.value });
    };

    handleChange = (item) => {
        let { selectedItem } = this.state;
        if (selectedItem.indexOf(item) === -1) {
            selectedItem = [...selectedItem, item];
        }
        this.props.onChange(this.props.name, selectedItem);
        this.setState({ inputValue: '', selectedItem });
    };

    handleDelete = (item) => () => {
        this.setState((state) => {
            const selectedItem = [...state.selectedItem];
            selectedItem.splice(selectedItem.indexOf(item), 1);
            this.props.onChange(this.props.name, selectedItem);
            return { selectedItem };
        });
    };

    render() {
        const { suggestions, label } = this.props;
        const { inputValue, selectedItem } = this.state;

        return (
            <Downshift
                inputValue={inputValue}
                onChange={this.handleChange}
                selectedItem={selectedItem}
            >
                {({
                    getInputProps,
                    getItemProps,
                    isOpen,
                    inputValue: inputValue2,
                    selectedItem: selectedItem2,
                    highlightedIndex,
                }) => (
                    <div className={'container'}>
                        {renderInput({
                            fullWidth: true,
                            InputProps: getInputProps({
                                startAdornment: selectedItem.map((item) => (
                                    <Chip
                                        key={randomstring()} //{item.id}
                                        tabIndex={-1}
                                        avatar={getAvatar(item.type)}
                                        label={item.name}
                                        className={'chip c_white bg_bluish'}
                                        onDelete={this.handleDelete(item)}
                                    />
                                )),
                                onChange: this.handleInputChange,
                                onKeyDown: this.handleKeyDown,
                                placeholder: label,
                                id: 'integration-downshift-multiple',
                            }),
                        })}
                        {isOpen && suggestions !== undefined ? (
                            <Paper className={'paper'} square>
                                {getSuggestions(suggestions, inputValue2).map((suggestion, index) =>
                                    renderSuggestion({
                                        suggestion,
                                        index,
                                        itemProps: getItemProps({
                                            item: {
                                                name: suggestion.name,
                                                id: suggestion.id,
                                                type: suggestion.type,
                                            },
                                        }),
                                        highlightedIndex,
                                        selectedItem: selectedItem2,
                                    }),
                                )}
                            </Paper>
                        ) : null}
                    </div>
                )}
            </Downshift>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/MultipleInput.js